/* eslint-disable react/button-has-type */
/* eslint-disable no-return-assign */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-danger */
/* eslint-disable consistent-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Box, Grid, Typography, Button, Paper, Tooltip, Card, CardContent, Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import BarChartIcon from '@mui/icons-material/BarChart';
import Popover from '@mui/material/Popover';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import "react-circular-progressbar/dist/styles.css";
import { useDispatch, useSelector } from 'react-redux';
import LaunchIcon from '@mui/icons-material/Launch';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import CoffeeIcon from "@mui/icons-material/Coffee";
import InsightsIcon from "@mui/icons-material/Insights";
import PsychologyIcon from "@mui/icons-material/Psychology";
import CloseIcon from '@mui/icons-material/Close';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Draggable from 'react-draggable';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import SendIcon from '@mui/icons-material/Send';
import Page from '../../../components/Page';
import adminServices from '../../../services/adminServices';
import LottieLoading from '../../../components/LottieLoading';
import Snackbar from '../../../components/snackbar/snackbar';
import TestComplete from '../../../assets/Images/TestComplete.png'
import { FromGeneralAssessmentView } from '../../../store/reducer'
import brakeTimeImg from "../../../assets/Images/breakTime.gif";
import Calculator from '../../../components/Calculator';
import IconCalculator from '../../../assets/Images/calculator.png';
import './index.css';
import AdaptiveQuestionPalette from './AdaptiveQuestionPalette';
import Breakscreen from './BreakScreen'
import useProctoring from './useProctoring';
import ProctoringWarningModal from './ProctoringWarningModal';

const AdativeAssessment = ({ assessmentId, fromIndex, details, onCallBack, resumeData, resumeLength, assessmenttitle, CallBackAssessmentView }) => {
  const dispatch = useDispatch()
  const intentionalExitRef = useRef(false);
  const { t } = useTranslation('translation');
  const allassessmentdetails = useSelector((state) => state);
  const isMobileDevice = () => {
  return /Android|iPhone|iPad|iPod|Mobi/i.test(navigator.userAgent) || window.innerWidth < 768;
};
  const { userInfo } = useSelector((state) => state);
  const [isLoading, setIsLoading] = useState(false);
  const [allDetails, setAllDetails] = useState('');
  const [questions, setQuestions] = useState([]);
  const [checked, setChecked] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();
  const [isTimeout, setIsTimeout] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [showBreakScreen, setShowBreakScreen] = useState(false);
  const [currentBreakScreen, setCurrentBreakScreen] = useState(null);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [openQuestionList, setOpenQuestionList] = useState(false);
  const [questionTimes, setQuestionTimes] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [startTime, setStartTime] = useState('');
  const [questionType, setQuestionType] = useState('Maths');
  const [currentSubject, setCurrentSubject] = useState(null);
  
  const [showCongratulationsModal, setShowCongratulationsModal] = useState(false);
  const [showCongratulations, setShowCongratulations] = useState(false);
  const [time, setTime] = useState(0);
  const [gridLeft, setGridLeft] = useState(6);
  const [gridRight, setGridRight] = useState(6);
  const [parsedOptions, setParsedOptions] = useState([]);
  const [submodule, setSubmodule] = useState(1);
  const [testView, setTestView] = useState(false);
  const [resumeTime, setResumeTime] = useState(false);
  const [timeLeft, setTimeLeft] = useState(600);
  const [correctAnswer, setCorrectAnswer] = useState([]);
  const [isopenSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarTitle, setSnackbarTitle] = useState('');
  const [showModuleComplete, setShowModuleComplete] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [markedForReview, setMarkedForReview] = useState({});
  const [breakTimeLeft, setBreakTimeLeft] = useState(600);
  const [openDrop, setOpendrop] = useState(false);
  const [overlayZIndex, setOverlayZIndex] = useState('none');
  const [questionListAnchorEl, setQuestionListAnchorEl] = useState(null);
  const [calculatorOpen, setCalculatorOpen] = useState(false);
  const handleCalculatorOpen = () => setCalculatorOpen(true);
  const handleCalculatorClose = () => setCalculatorOpen(false);
  const [currentValues, setCurrentValues] = useState(null);
  const calcDraggedRef = useRef(false);
  const calcDragStartPos = useRef({ x: 0, y: 0 });
  const calcVelocity = useRef({ x: 0, y: 0 });
  const calcLastPos = useRef({ x: 0, y: 0 });
  const calcLastTime = useRef(0);
  const calcInertiaRef = useRef(null);
  const calcIsDragging = useRef(false);
  const calcPos = useRef({ x: window.innerWidth - 76, y: window.innerHeight - 132 });
  const [visitedMap, setVisitedMap] = useState({ 0: true });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [proctoringActive, setProctoringActive] = useState(false);
  const { violationCount, showWarning, lastViolationType, autoSubmitted, dismissWarning } = useProctoring({
    assessmentId: parseInt(assessmentId, 10) || details?.id || null, userId: userInfo?.id, attemptCount: fromIndex, active: proctoringActive,
    onAutoSubmit: () => handlePostUserResult('timeout'),
  });

  const getCurrentTime = () => {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const seconds = now.getSeconds().toString().padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  };

  const navigateToOverview = React.useCallback(() => {
    onBack()
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue =
        "Are you sure you want to leave? Your progress will not be saved.";
      return event.returnValue;
    };

   const handlePopState = (event) => {
  event.preventDefault();
  window.history.pushState(null, "", window.location.pathname);

  if (testViewRef.current && !showBreakScreenRef.current) {
    if (backExitRef.current) return;
    backExitRef.current = true;
    handlePostUserResult("back");
    return;
  }

  navigateToOverview();
};
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handlePopState);
    window.history.pushState(null, "", window.location.pathname);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, [])

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

const exitFullscreenSafely = () => {
  intentionalExitRef.current = true;
  if (document.fullscreenElement) {
    document.exitFullscreen().catch((e) => console.log('exit fullscreen error', e));
  }
  setProctoringActive(false);
};

useEffect(() => {
  const handleFullscreenChange = () => {
    const isNowFullscreen = !!document.fullscreenElement;

    if (!isNowFullscreen && testViewRef.current && !showBreakScreenRef.current && !intentionalExitRef.current) {
      // Fullscreen was dropped by the OS/browser (e.g. swipe-down gesture) — re-enter it
      try {
        const requestFs = isMobileDevice()
          ? document.documentElement.requestFullscreen({ navigationUI: 'hide' })
          : document.documentElement.requestFullscreen();
        requestFs?.catch((e) => console.log('re-enter fullscreen error', e));
      } catch (e) {
        console.log('re-enter fullscreen error', e);
      }
    }

    intentionalExitRef.current = false;
  };

  document.addEventListener('fullscreenchange', handleFullscreenChange);
  return () => {
    document.removeEventListener('fullscreenchange', handleFullscreenChange);
  };
}, []);

  const onStartTest = () => {
      try {
    if (isMobileDevice()) {
      document.documentElement.requestFullscreen({ navigationUI: 'hide' });
    } else {
      document.documentElement.requestFullscreen();
    }
  } 
     catch(e) {console.log('error',e)}
    setProctoringActive(true);
    setStartTime(Date.now());
    setTimeout(() => {
      setTestView(true)
      setTime(currentSubject?.time * 60)
    }, 1000);
  
    dispatch(FromGeneralAssessmentView(true));
  }
  const onBack = (data) => {
    dispatch(FromGeneralAssessmentView(false));
    onCallBack(assessmentId, details, true)
    CallBackAssessmentView(fromIndex || 0, 1, true, data);
  }



  const handleOpenQuestionList = (event) => {
    setQuestionListAnchorEl(event.currentTarget);
    setOverlayZIndex('block');
  };

  const handleCloseQuestionList = () => {
    setQuestionListAnchorEl(null);
    setOverlayZIndex('none');
  };

  const getAssessmentDetails = async (type) => {
    setIsLoading(true);
    setCalculatorOpen(false)
    const result = await adminServices.getStartAssessment(assessmentId, details?.assessment_pattern_name);    
    setCurrentIndex(0)
    if (result.ok) {
      setAllDetails(result?.data?.assessmentDetails);
      setCurrentSubject({
        ...result.data.section,        
        sectionIndex: result.data.sectionIndex,   
        variantIndex: result.data.variantIndex,   
        percentage:   undefined    });
      const newQuestions = result.data?.section?.questions || [];
      setQuestions(newQuestions);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getAssessmentDetails();

}, []);
 
  const currentQuestion = questions && questions[currentIndex];
  const parsedData = typeof currentQuestion?.options === 'string'
    ? JSON.parse(currentQuestion?.options)
    : currentQuestion?.options;



  const getQuestionHtml = (value) => {
    if (!value) return "";

    if (typeof value === "string") {
      return value;
    }

    return String(value);
  };

  const questionHtml = getQuestionHtml(currentQuestion?.question_text);
  const correctAnswers = parsedData?.correctAnswer || [];

  function convertComplexity(level) {
    switch (level.toLowerCase()) {
      case 'easy':
        return 'Beginner';
      case 'medium':
        return 'Intermediate';
      case 'hard':
        return 'Advanced';
      default:
        return level;
    }
  }

  const formatOptionHtml = (html) => {
    if (!html || typeof html !== 'string') return '';

    return html
      .replace(/<p><br><\/p>/g, '')
      .replace(/<p>/g, '<span>')
      .replace(/<\/p>/g, '</span>')
      .replace(/<\/span><span>/g, ' </span><span>');
  };

  const selectedAnswersRef = useRef(selectedAnswers);
  const questionTimesRef = useRef(questionTimes);
  const startTimeRef = useRef(startTime);
  const currentIndexRef = useRef(currentIndex);
  const questionsRef = useRef(questions);
  const currentSubjectRef = useRef(currentSubject);
  const testViewRef = useRef(testView);
  const isPausedRef = useRef(isPaused);
  const showBreakScreenRef = useRef(showBreakScreen);

  useEffect(() => { selectedAnswersRef.current = selectedAnswers; }, [selectedAnswers]);
  useEffect(() => { questionTimesRef.current = questionTimes; }, [questionTimes]);
  useEffect(() => { startTimeRef.current = startTime; }, [startTime]);
  useEffect(() => { currentIndexRef.current = currentIndex; }, [currentIndex]);
  useEffect(() => { questionsRef.current = questions; }, [questions]);
  useEffect(() => { currentSubjectRef.current = currentSubject; }, [currentSubject]);
  useEffect(() => { testViewRef.current = testView; }, [testView]);
  useEffect(() => { isPausedRef.current = isPaused; }, [isPaused]);
  useEffect(() => { showBreakScreenRef.current = showBreakScreen; }, [showBreakScreen]);

  const lastUpdateRef = useRef(Date.now());
  const backgroundStartRef = useRef(null);
  const timerRef = useRef(null);
  const isTimeoutRef = useRef(false);
  const backExitRef = useRef(false); 

  const handlePostUserResult = async (value) => {
    try {
      setOpenConfirmDialog(false);
      setIsLoading(true);
      const latestSelectedAnswers = selectedAnswersRef.current;
      const latestQuestionTimes = questionTimesRef.current;
      const latestStartTime = startTimeRef.current;
      const latestCurrentIndex = currentIndexRef.current;
      const latestQuestions = questionsRef.current;
      const latestCurrentSubject = currentSubjectRef.current;

      const endTime = Date.now();
      const lastQuestionTime = latestStartTime ? (endTime - latestStartTime) / 1000 : 0;

      const updatedQuestionTimes = {
        ...latestQuestionTimes,
        [latestCurrentIndex]: (latestQuestionTimes[latestCurrentIndex] || 0) + lastQuestionTime,
      };

      const totalTimeTaken = Object.values(updatedQuestionTimes).reduce(
        (acc, t) => acc + t, 0
      );

      const formattedSelectedAnswers =
        latestQuestions && latestQuestions.length > 0
          ? latestQuestions.map((question, index) => ({
            questionId: question.id,
            type: question.level,
            index,
            selectedAnswer: latestSelectedAnswers[index] || null,
            timeTaken: updatedQuestionTimes[index] || 0,
            multiplier: question?.cognitive_skill_id,
          }))
          : [];

      const body = {
        type: questionType,
        assessment_id: assessmentId || allDetails?.id,
        user_id: userInfo?.id,
        user_result: formattedSelectedAnswers,
        date_started: getCurrentTime(),
        date_completed: getCurrentTime(),
        difference_date: totalTimeTaken,
        attemptCount: fromIndex,
        submodules: submodule,
        section: questionType,
        last: submodule === 2 && questionType === "Maths",
        name: details.title,
        description: details.short_description,
        SATtype: details.type,
        level: convertComplexity('Easy'),
        subscribedDate: details.created_date_time,
        current_Section: latestCurrentSubject?.sectionName,
        flowType: latestCurrentSubject?.flowType,
        sectionIndex: latestCurrentSubject?.sectionIndex ?? 0,
        variantIndex: latestCurrentSubject?.variantIndex ?? 0,
        percentage: latestCurrentSubject?.percentage ?? undefined,
      };

      const result = await adminServices.postSATResult(body);
      setMarkedForReview({});


      if (result.ok) {

        if (value === 'timeout' || value === 'back') {
           exitFullscreenSafely(); 
          setShowCongratulations(true);
          setShowCongratulationsModal(true);
          setAllDetails('');
          setCurrentSubject(null);
          setCurrentIndex(0);
          setQuestions([]);
          setShowModuleComplete(false);
          setSelectedAnswers({});
          setOpenQuestionList(false);
          setStartTime(Date.now());
          setQuestionTimes([]);
          setIsLoading(false);
          setIsSubmitting(false);
          setTimeout(() => {
            // Close the congrats <Dialog> and release the body scroll-lock
            // BEFORE the parent unmounts this component. A MUI Dialog left
            // mounted-and-open at unmount corrupts MUI's shared
            // ModalManager refcount and leaves `body { overflow: hidden }`
            // stuck on the assessment overview page we land on.
            setShowCongratulationsModal(false);
            setShowCongratulations(false);
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
            document.body.style.removeProperty('padding-right');
            setTimeout(() => onBack("exam"), 0);
          }, 3000);
        }
        else if (result.data?.nextFlow === "COMPLETED") {
          setCurrentValues(result.data)
          exitFullscreenSafely();
          setShowCongratulations(true);
          setShowCongratulationsModal(true);
          setAllDetails('');
          setCurrentSubject(null);
          setCurrentIndex(0);
          setQuestions([]);
          setShowModuleComplete(false);
          setSelectedAnswers({});
          setOpenQuestionList(false);
          setStartTime(Date.now());
          setQuestionTimes([]);
          setIsLoading(false);
          setIsSubmitting(false);
          setTimeout(() => {
            // Close the congrats <Dialog> and release the body scroll-lock
            // BEFORE the parent unmounts this component. A MUI Dialog left
            // mounted-and-open at unmount corrupts MUI's shared
            // ModalManager refcount and leaves `body { overflow: hidden }`
            // stuck on the assessment overview page we land on.
            setShowCongratulationsModal(false);
            setShowCongratulations(false);
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
            document.body.style.removeProperty('padding-right');
            setTimeout(() => onBack("exam"), 0);
          }, 3000);

        } else if (result.data?.nextFlow ==='SECTION' && details?.break_screens?.find((b) => b.position === result.data?.variantIndex)) {
          setShowBreakScreen(true);
          setCurrentBreakScreen(details?.break_screens?.find((b) => b.position === result.data?.variantIndex));
          setIsLoading(false);
          setAllDetails(result?.data?.assessmentDetails);
          setCurrentSubject({
            ...result.data.section,
            sectionIndex: result.data.sectionIndex,
            variantIndex: result.data.variantIndex,
            percentage: undefined
          });

          setTime(result.data?.section?.time * 60)
          setCurrentIndex(0);
          const newQuestions = result.data?.section?.questions || [];
          setQuestions(newQuestions);
          setQuestionTimes([]);
          setSelectedAnswers({});      
          setMarkedForReview({});      
          setVisitedMap({ 0: true });
          setIsLoading(false);
          setIsSubmitting(false);
        }
        else {
          setAllDetails(result?.data?.assessmentDetails);
          setCurrentSubject({
            ...result.data.section,
            sectionIndex: result.data.sectionIndex,
            variantIndex: result.data.variantIndex,
            percentage: undefined
          });

          setTime(result.data?.section?.time * 60)
          setCurrentIndex(0);
          const newQuestions = result.data?.section?.questions || [];
          setQuestions(newQuestions);
          setShowModuleComplete(false);
          setSelectedAnswers([]);
          setOpenQuestionList([]);
          setStartTime(Date.now());
          setQuestionTimes([]);
          setVisitedMap({ 0: true });
          setIsLoading(false);
          setIsSubmitting(false);

        }
        isTimeoutRef.current = false
      }
    }
    catch (error) {
      console.error("Error posting user result:", error);
      setIsLoading(false);
    }
  };

  const timeRef = useRef(time);
  useEffect(() => { timeRef.current = time; }, [time]);

  const getAccurateElapsed = () => {
    const now = Date.now();
    let elapsed = 0;
    if (backgroundStartRef.current) {
      elapsed = backgroundStartRef.current - lastUpdateRef.current;
      elapsed += now - backgroundStartRef.current;
      backgroundStartRef.current = null;
    } else {
      elapsed = now - lastUpdateRef.current;
    }
    lastUpdateRef.current = now;
    return Math.floor(elapsed / 1000);
  };

  const startTimerRef = useRef(null);
  const updateTimerRef = useRef(null);

  updateTimerRef.current = () => {
    const elapsedSeconds = getAccurateElapsed();
    setTime(prev => {
      const newTime = prev - elapsedSeconds;
      if (newTime <= 0) {
        if (testViewRef.current && !showBreakScreenRef.current && !isTimeoutRef.current) {
          isTimeoutRef.current = true;
          setIsTimeout(true);
          setTimeout(() => handlePostUserResult(), 0);
        }
        return 0;
      }
      return newTime;
    });
  };

  startTimerRef.current = () => {
    clearInterval(timerRef.current);
    if (!isPausedRef.current && timeRef.current > 0) {
      timerRef.current = setInterval(() => updateTimerRef.current(), 1000);
    }
  };

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        clearInterval(timerRef.current);
        backgroundStartRef.current = Date.now();
      } else {
        updateTimerRef.current();
        startTimerRef.current();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);

  useEffect(() => {
    lastUpdateRef.current = Date.now();
    startTimerRef.current();
    return () => clearInterval(timerRef.current);
  }, [isPaused, time]);


  const handleNavigateAnalysis = () => {
    setResumeTime(false)
    if (userInfo.role === 'AUTH_USER') {
      navigate(`/app/assessment/${encodeURIComponent(details?.title)}/${assessmentId}`, {
        state: {
          id: assessmentId,
          comingFrom: 'ComingfromAnalysis',
          fromindex: fromIndex,
          data: details
        }
      })
    } else {
      navigate(`/auth/assessment/${encodeURIComponent(details?.title)}/${assessmentId}`, {
        state: {
          id: assessmentId,
          comingFrom: 'ComingfromAnalysis',
          fromindex: fromIndex,
          data: details
        }
      })
    }

    setQuestionType('English')
    setSubmodule(1)
    dispatch(FromGeneralAssessmentView(false));
    CallBackAssessmentView(fromIndex || 0, 1, true);
  }

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const formatTimeTimer = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const formatTimeTimerDisplay = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    return `${hours.toString().padStart(2, '0')} Hours${minutes.toString().padStart(2, '0')} Minutes`;
  };

  const handleNext = () => {
    const endTime = Date.now();
    const timeSpent = (endTime - startTime) / 1000;
    const currentQuestion = questions[currentIndex];
    setStartTime(Date.now());
    setQuestionTimes((prev) => ({
      ...prev,
      [currentIndex]: (prev[currentIndex] || 0) + timeSpent,
    }));


    if (currentIndex < questions.length - 1) {
      setVisitedMap(prev => ({ ...prev, [currentIndex + 1]: true }));
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handleMarkForReviewAndNext = () => {
    handleBookmarkTrue(currentIndex);
    if (currentIndex < questions.length - 1) {
      handleNext();
    } else {
      setCurrentIndex(0);
      setStartTime(Date.now());
    }
  };

  const handleBack = () => {
    if (currentIndex > 0) {
      const endTime = Date.now();
      const timeSpent = (endTime - startTime) / 1000;

      setQuestionTimes((prev) => ({
        ...prev,
        [currentIndex]: (prev[currentIndex] || 0) + timeSpent,
      }));

      setStartTime(Date.now());
      setVisitedMap(prev => ({ ...prev, [currentIndex - 1]: true }));
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleOptionSelect = (option, index) => {
    try {
      setSelectedAnswers((prev) => ({
        ...prev,
        [currentIndex]: option,
      }));
    } catch (error) {
      setCorrectAnswer((prev) => ({
        ...prev,
        [currentIndex]: "incorrect",
      }));
      setSelectedAnswers((prev) => ({
        ...prev,
        [currentIndex]: option,
      }));
    }
  };


  const handleQuestionSelect = (index) => {
    const endTime = Date.now();
    const timeSpent = (endTime - startTime) / 1000;

    setQuestionTimes((prev) => ({
      ...prev,
      [currentIndex]: (prev[currentIndex] || 0) + timeSpent,
    }));

    setStartTime(Date.now());
    setVisitedMap(prev => ({ ...prev, [index]: true }));
    setCurrentIndex(index);
    handleCloseQuestionList();
  };



  const handleSubmit = async () => {
    if (isLoading || isSubmitting) return;
    setIsSubmitting(true);
    setOpenConfirmDialog(true);

  };



  const handleBookmarkTrue = (index) => {
    setMarkedForReview((prevState) => ({
      ...prevState,
      [index]: true,
    }));
  };

  const handleBookmarkFalse = (index) => {
    setMarkedForReview((prevState) => ({
      ...prevState,
      [index]: false,
    }));
  };


  useEffect(() => {
    if (currentQuestion && currentQuestion.options) {
      try {
        const parsed = typeof currentQuestion.options === 'string'
          ? JSON.parse(currentQuestion.options)
          : currentQuestion.options;

        setParsedOptions(parsed.mcqOptions);
      } catch (error) {
        console.error("Failed to parse options:", error);
        setParsedOptions([]);
      }
    }
  }, [currentQuestion]);

  const handleNextModule = () => {
    setTime(2100)
    setQuestionType('Maths');
    getAssessmentDetails('Maths');
    setStartTime(Date.now())
    setCalculatorOpen(false)
    setSubmodule(1);
    setResumeTime(false);
    setBreakTimeLeft(600);

  }

  const handleClearResponse = () => {
    setSelectedAnswers((prev) => {
      const newAnswers = { ...prev };
      delete newAnswers[currentIndex];
      return newAnswers;
    });

    setCorrectAnswer((prev) => {
      const newCorrectAnswers = { ...prev };
      delete newCorrectAnswers[currentIndex];
      return newCorrectAnswers;
    });

    setMarkedForReview((prev) => ({
      ...prev,
      [currentIndex]: false,
    }));
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOverlayZIndex('block');
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOverlayZIndex('none');
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const handleCalcMouseDown = (e) => {
    e.preventDefault();
    calcIsDragging.current = true;
    calcDraggedRef.current = false;
    calcDragStartPos.current = { x: e.clientX, y: e.clientY };
    calcLastPos.current = { x: e.clientX, y: e.clientY };
    calcLastTime.current = Date.now();
    calcVelocity.current = { x: 0, y: 0 };
    cancelAnimationFrame(calcInertiaRef.current);

    const onMouseMove = (me) => {
      if (!calcIsDragging.current) return;
      const now = Date.now();
      const dt = now - calcLastTime.current || 16;
      const dx = me.clientX - calcLastPos.current.x;
      const dy = me.clientY - calcLastPos.current.y;

      calcVelocity.current = { x: dx / dt * 16, y: dy / dt * 16 };
      calcLastPos.current = { x: me.clientX, y: me.clientY };
      calcLastTime.current = now;

      const nx = calcPos.current.x + dx;
      const ny = calcPos.current.y + dy;
      const bx = Math.min(Math.max(nx, 0), window.innerWidth - 52);
      const by = Math.min(Math.max(ny, 0), window.innerHeight - 52);
      calcPos.current = { x: bx, y: by };

      const el = document.getElementById('calc-drag-icon');
      if (el) { el.style.left = `${bx}px`; el.style.top = `${by}px`; }

      const moved = Math.abs(me.clientX - calcDragStartPos.current.x) > 5
        || Math.abs(me.clientY - calcDragStartPos.current.y) > 5;
      if (moved) calcDraggedRef.current = true;
    };

    const onMouseUp = () => {
      calcIsDragging.current = false;
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
      applyInertia();
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  const applyInertia = () => {
    const friction = 0.88;
    const animate = () => {
      calcVelocity.current.x *= friction;
      calcVelocity.current.y *= friction;

      if (Math.abs(calcVelocity.current.x) < 0.3 && Math.abs(calcVelocity.current.y) < 0.3) return;

      const nx = calcPos.current.x + calcVelocity.current.x;
      const ny = calcPos.current.y + calcVelocity.current.y;
      const bx = Math.min(Math.max(nx, 0), window.innerWidth - 52);
      const by = Math.min(Math.max(ny, 0), window.innerHeight - 52);

      if (nx <= 0 || nx >= window.innerWidth - 52) calcVelocity.current.x *= -0.4;
      if (ny <= 0 || ny >= window.innerHeight - 52) calcVelocity.current.y *= -0.4;

      calcPos.current = { x: bx, y: by };
      const el = document.getElementById('calc-drag-icon');
      if (el) { el.style.left = `${bx}px`; el.style.top = `${by}px`; }

      calcInertiaRef.current = requestAnimationFrame(animate);
    };
    calcInertiaRef.current = requestAnimationFrame(animate);
  };


  return (
    <Page title={'Begin Course'} style={{ marginTop: '8px', padding: '0px', paddingTop: '56px !important', overflow: showCongratulations ? 'auto' : 'hidden', height: '100vh' }}>
      {showBreakScreen && currentBreakScreen ? (
        <Breakscreen
          breakScreen={currentBreakScreen}
          onResume={() => {
            setShowBreakScreen(false);
            setCurrentBreakScreen(null);
            setTime(currentSubject?.time * 60)
            setStartTime(Date.now());
          }}
          style={{ marginBottom: '10px' }}
        />
      ) :
        <>

          <Box className="overLay" style={{
            opacity: '1', transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1)', position: 'fixed',
            justifyContent: 'center', right: '0', bottom: '0', top: '0', left: '0',
            display: overlayZIndex,
            backgroundColor: 'rgb(12 12 12 / 35%)', zIndex: '1101', width: '100vw',
            height: '100vh'
          }} />
          {testView === false && !showCongratulations && (() => {
            const isFullTest = details?.assessment_type === 'Full Test';
            const instructionItems = isFullTest ? [
              "Treat this as a real examination. Ensure you are in a quiet environment with no distractions.",
              `The ${details?.title} a computer-adaptive test divided into 2 sections: Reading & Writing and Math`,
              "Each section consists of two modules. You cannot return to a previous module once it has been submitted.",
              "There is a mandatory 10-minute break between the Reading & Writing and Math sections.",
              "You may skip the break screen if you wish to proceed, but we recommend taking the full time to mimic real exam conditions.",
              "Use the 'Mark for Review' feature to flag questions you want to return to later within the same module.",
              "The question palette at the bottom allows you to track your progress and quickly jump between questions.",
              "If you encounter any technical issues, please take a screenshot and send it to our support team immediately.",
              "The test will auto-submit when the time for each module expires.",
              "Ensure your device is fully charged and you have a stable internet connection before starting.",
            ] : [
              "Treat this as a real examination. Ensure you are in a quiet environment with no distractions.",
              `The ${details?.title} a computer-adaptive test where you get next module based on your performance`,
              "This section consists of ONE modules. You cannot return to a previous module once it has been submitted.",
              "There is NO mandatory 10-minute break between Module 1 and the adaptive Module 2",
              "We recommend taking full time to complete the test with all your heart to mimic real exam conditions.",
              "Use the 'Mark for Review' feature to flag questions you want to return to later within the same module.",
              "The question palette at the bottom allows you to track your progress and quickly jump between questions.",
              "If you encounter any technical issues, please take a screenshot and send it to our support team immediately.",
              "The test will auto-submit when the time for each module expires.",
              "Ensure your device is fully charged and you have a stable internet connection before starting.",
            ];
            return (
              <div className="min-h-screen bg-gray-100 p-6">
                <div className="max-w-6xl mx-auto">
                  <div className=" bg-white rounded border border-[#F3F4F6] p-4 mb-8  max-h-[50vh] md:max-h-[60vh] lg:max-h-none overflow-y-auto lg:overflow-visible">
                    <h2 className="text-sm font-bold text-gray-900 mb-3 flex items-center gap-2">
                      <span className="w-5 h-5 rounded-full border-2 border-gray-900 flex items-center justify-center text-xs text-gray-900 font-bold flex-shrink-0">i</span>
                      General Instructions
                    </h2>
                    <ol className="list-none pl-0 m-0 flex flex-col" style={{ gap: '12px' }}>
                      {instructionItems.map((text, i) => (
                        <li key={i} className="flex items-center gap-3">
                          <span style={{
                            width: '16px', height: '16px', backgroundColor: 'transparent',
                            borderRadius: '2px', border: '1px solid #d1d5db', display: 'flex',
                            alignItems: 'center', justifyContent: 'center', fontSize: '10px',
                            color: '#000000', fontFamily: 'Inter', fontWeight: 400,
                            lineHeight: '16px', flexShrink: 0, textAlign: 'center'
                          }}>
                            {i + 1}
                          </span>
                          <span style={{ fontFamily: 'Inter', fontWeight: 400, fontSize: '14px', lineHeight: '16px', color: '#374151' }}>
                            {text}
                          </span>
                        </li>
                      ))}
                    </ol>
                  </div>
                  <div className="border border-gray-200 rounded-2xl overflow-hidden">
                    <div className="bg-white px-4 py-2 flex items-start gap-4">
                      <input type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)} className="mt-1 h-4 w-4 rounded border-gray-400" />
                      <p className="text-gray-800 text-[15px] leading-relaxed">
                        <b>Declaration: </b>I have read and understood all the instructions and agree to the examination rules. I understand that any violation of rules may lead to disqualification.
                      </p>
                    </div>
                    <div className="bg-white px-4 py-4 flex items-center justify-between w-full">
                      <button onClick={() => onBack("back")} className="flex items-center gap-2 px-6 py-2.5 rounded-lg font-semibold border border-gray-300 text-gray-700 hover:bg-gray-100 transition-all duration-200">
                        <ChevronLeftIcon sx={{ fontSize: 20 }} />
                        Back
                      </button>
                      <button  onClick={onStartTest} disabled={!checked && testView === false} className={`flex items-center gap-2 px-6 py-2.5 rounded-lg font-semibold transition-all duration-200 ${checked ? "bg-[#2F62D6] hover:bg-[#244fb5] text-white" : "bg-gray-300 text-gray-500 cursor-not-allowed"}`}>
                        Start Examination
                        <SendIcon sx={{ fontSize: 20 }} />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })()}


      {resumeTime && testView === true &&
        ((details?.assessment_type === 'Full Test') && (
          <>
            {resumeTime && questionType === 'English' &&

              <Box classname="breaktimeMain" style={{ paddingTop: '45px', minHeight: '80vh', backgroundColor: '#fff' }} sx={{ flexGrow: 1, maxWidth: '90%', margin: "auto" }}>
                <Box elevation={3} sx={{ padding: 3, borderRadius: 0 }}>
                  <Grid container spacing={2}>

                    <Grid item xs={12} md={8} style={{ paddingLeft: '55px' }}>
                      <Typography variant="h5" fontWeight="bold">
                        SAT Test Break
                      </Typography>
                      <Typography variant="body1" sx={{ mt: 1 }}>
                        You can wait till the clock counts down or resume the test if you’re ready to start the next module.
                      </Typography>
                      <Box sx={{ my: 2, borderBottom: "1px solid #ccc" }} />

                          <Typography variant="h6" fontWeight="bold">
                            Take a Break: Do not close your browser tab.
                          </Typography>
                          <Typography variant="body2" sx={{ mt: 1 }}>
                            After the break time counter counts down to zero, the test starts automatically. But if you are ready to start the test, you can click/tap on the <strong>“Resume Test”</strong> button below the timer.
                          </Typography>

                      <Typography variant="body2" sx={{ mt: 1 }}>
                        If you close your browser now, you can resume the test, but please remember that you will directly from the next module.
                      </Typography>

                      <Typography variant="subtitle1" fontWeight="bold" sx={{ mt: 2, marginBottom: 1 }}>
                        Follow these rules while the break timer counts down.</Typography>
                      <Typography variant="body2" component="ol" sx={{ pl: 2 }}>
                        <li style={{ marginBottom: "5px" }}>DO NOT try to check your answers or open any external assistance to help you complete the assessment. </li>
                        <li style={{ marginBottom: "5px" }}>TRY to be genuine while attending the practice test.</li>
                        <li style={{ marginBottom: "5px" }}>BELIEVE that this is a real SAT test.</li>
                        <li style={{ marginBottom: "5px" }}>DO NOT click the <strong>“Back”</strong> or <strong>“Refresh”</strong> button on your browser.</li>
                        <li style={{ marginBottom: "5px" }}>DO NOT restart or shut down your laptop.</li>
                        <li style={{ marginBottom: "5px" }}>DO NOT close the browser.</li>
                        <li style={{ marginBottom: "5px" }}>Please keep your environment just like the test environment.</li>

                      </Typography>
                    </Grid>

                        <Grid item xs={12} md={4} textAlign="center">
                          <Box style={{
                            '@media (min-width: 900px)': {
                              borderLeft: '1px solid #ccc'
                            }
                          }} sx={{
                            borderLeft: {
                              xs: 'none',
                              md: '1px solid #ccc'
                            }, marginBottom: { xs: '20px !important', sm: '15px !important', md: '0px !important' }
                          }}>
                            <img src={brakeTimeImg} alt="Break Time" style={{ width: "100%", maxWidth: "180px", margin: 'auto', marginBottom: "10px" }} />
                            <Box style={{ height: '110px', display: 'flex', flexDirection: 'column', justifyContent: 'center', marginTop: '20px' }}
                              sx={{
                                backgroundColor: "#437bfc",
                                color: "white",
                                width: '80%',
                                minWidth: '220px',
                                maxWidth: '280px',
                                padding: '10px 0 15px',
                                borderRadius: "8px",
                                fontSize: "1.5rem",
                                fontWeight: "bold",
                                margin: "auto",
                              }}
                            >
                              <p style={{ fontSize: "18px", marginBottom: '8px', fontWeight: '400' }}>Remaining Break Time</p>
                              {formatTime(breakTimeLeft)}
                            </Box>
                            <Button onClick={handleNextModule} variant="contained" color="success"
                              style={{
                                width: '80%',
                                minWidth: '220px',
                                maxWidth: '280px',
                                backgroundColor: '#52c28c',
                                color: '#fff',
                                borderRadius: '4px',
                                fontSize: '16px',
                                fontWeight: '400'
                              }}
                              sx={{ mt: 2, width: "100%" }}
                            >
                              Resume Test
                            </Button>
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                }
                {resumeTime && questionType === 'Maths' &&
                  <>
                    <div style={{ marginTop: '100px', paddingBottom: '10px' }}>
                      <div className="flex flex-col items-center justify-center min-h-[50vh] bg-red-100 testStatus" style={{ boxShadow: 'rgb(41 102 247) 0px 2px 4px 0px, rgb(41 102 247) 0px 2px 16px 0px', background: '#fff', justifyItems: 'center', margin: 'auto', borderRadius: '10px', flexDirection: 'column' }} >
                        <div className="flex justify-center mb-4">
                          <div className="relative inline-block">
                            <img style={{ justifySelf: 'center' }} src={TestComplete} alt="Timeout Icon" className="w-16 h-16" />
                          </div>
                        </div>

                        <h2 className="text-xl font-bold text-blue-600" style={{ textAlign: 'center', marginTop: '5px', fontWeight: '700', color: "#6c98fd !important" }}>Test Completed</h2>
                        <p className="text-gray-600 mt-2" style={{ textAlign: 'center', marginTop: '10px' }}>
                          You have completed the assessment. Please note that you have exhausted 1 attempt from your quota. To know the answers, please click on the button below!    </p>
                        <Button
                          variant="outlined"
                          onClick={handleNavigateAnalysis}
                          sx={{
                            marginTop: '25px',
                            display: 'flex',
                            borderColor: "#3B82F6",
                            borderRadius: '4px !important',
                            color: "#3B82F6",
                            padding: '4px 18px !important',
                            "&:hover": {
                              backgroundColor: "#3B82F6",
                              color: "#fff",
                              borderColor: '#3B82F6',
                            },
                          }}
                        >  View Analysis</Button>

                      </div>
                    </div>
                  </>
                }
              </>
            ))
            ||
            (resumeTime && testView === true && details?.assessment_type && (questionType === 'Maths' || questionType === 'English') && (
              <>
                <div style={{ marginTop: '100px', paddingBottom: '10px' }} >
                  <div className="flex flex-col items-center justify-center min-h-[50vh] bg-red-100 testStatus" style={{ boxShadow: 'rgb(41 102 247) 0px 2px 4px 0px, rgb(41 102 247) 0px 2px 16px 0px', background: '#fff', justifyItems: 'center', margin: 'auto', borderRadius: '10px' }} >
                    <div className="flex justify-center mb-4">
                      <div className="relative inline-block">
                        <img style={{ justifySelf: 'center' }} src={TestComplete} alt="Timeout Icon" className="w-16 h-16" />
                      </div>
                    </div>

                    <h2 className="text-xl font-bold text-blue-600" style={{
                      textAlign: 'center',
                      marginTop: '5px', fontWeight: '700', color: "#6c98fd !important"
                    }}>Test Completed</h2>
                    <p className="text-gray-600 mt-2" style={{
                      textAlign: 'center', marginTop: '10px'
                    }}>
                      You have completed the assessment. Please note that you have exhausted 1 attempt from your quota. To know the answers, please click on the button below!    </p>
                    <Button
                      variant="outlined"
                      onClick={handleNavigateAnalysis}
                      sx={{
                        marginTop: '25px',
                        display: 'flex',
                        borderColor: "#3B82F6",
                        borderRadius: '4px !important',
                        color: "#3B82F6",
                        padding: '4px 18px !important',
                        "&:hover": {
                          backgroundColor: "#3B82F6",
                          color: "#fff",
                          borderColor: '#3B82F6',
                        },
                      }}
                    >  View Analysis</Button>

                  </div>
                </div>
              </>
            ))
          }
          {!resumeTime && testView === true &&
            <>
              <Box sx={{ display: "flex", flexDirection: "column", backgroundColor: "#EFF6FF", minHeight: '100vh', overflow: 'auto' }}>
           {!isLoading &&
  <Box id="topicHead" sx={{ backgroundColor: '#EFF6FF', py: 1, mt: 3 }}>
    <Box sx={{
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' },
      alignItems: 'center',
      position: 'relative',
      rowGap: 1.5,
      maxWidth: '1400px',
      mt: 0.5,
      width: '96%',
      margin: '0 auto',
      px: '20px',
      gap: 2
    }}>
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: { xs: 'space-between', sm: 'flex-start' },
        width: { xs: '100%', sm: 'auto' },
        gap: 2,
      }}>
        <Button
          onClick={handleClick} id='button'
          variant="outlined"
          endIcon={<KeyboardArrowDownIcon />}
          sx={{
            textTransform: 'none', fontSize: '13px', color: '#333', fontWeight: 500,
            borderColor: '#E5E7EB', borderRadius: '6px', whiteSpace: 'nowrap',
            height: '40px', width: '122px', gap: '6px', flexShrink: 0,
            backgroundColor: '#F9FAFB',
            boxShadow: '0px 1px 0.5px 0.05px #1D293D05',
            paddingTop: '10px', paddingBottom: '10px',
            paddingLeft: '16px', paddingRight: '16px',
            '&:hover': { borderColor: '#d1d5db', backgroundColor: '#F3F4F6' }
          }}
        >
          Directions
        </Button>

        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          slotProps={{ paper: { sx: { borderRadius: '12px', border: '1px solid #e5e7eb', p: 1, marginTop: '4px', marginLeft: '-9px' } } }}
          disablePortal
        >
          <Box sx={{ minWidth: { xs: '80vw', sm: '600px' }, display: 'flex', flexDirection: 'column', gap: 1 }}>
 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" style={{ width: '18px', height: '18px', flexShrink: 0 }}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                              </svg>
                              <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#111827' }}>
                                Directions for Test
                              </Typography>
                            </Box>
                            {[
                              'Treat this as a real examination. Ensure you are in a quiet environment with no distractions.',
                              `The ${details?.title} is a computer-adaptive test divided into 2 sections: Reading & Writing and Math.`,
                              'Each section consists of two modules. You cannot return to a previous module once it has been submitted.',
                              'There is a mandatory 10-minute break between the Reading & Writing and Math sections.',
                              'You may skip the break screen if you wish to proceed, but we recommend taking the full time to mimic real exam conditions.',
                              "Use the 'Mark for Review' feature to flag questions you want to return to later within the same module.",
                              'The question palette at the bottom allows you to track your progress and quickly jump between questions.',
                              'If you encounter any technical issues, please take a screenshot and send it to our support team immediately.',
                              'The test will auto-submit when the time for each module expires.',
                              'Ensure your device is fully charged and you have a stable internet connection before starting.',
                            ].map((item, index) => (
                              <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <Box sx={{ minWidth: '24px', height: '24px', borderRadius: '4px', border: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#6b7280' }}>
                                    {index + 1}
                                  </Typography>
                                </Box>
                                <Typography sx={{ fontSize: '13px', color: '#374151', lineHeight: '1.5' }}>
                                  {item}
                                </Typography>
                              </Box>
                            ))}          </Box>
        </Popover>

        <Box sx={{
  position: { xs: 'static', lg: 'absolute' },
  left: { lg: '50%' },
  top: { lg: '50%' },
  transform: { lg: 'translate(-50%, -50%)' },
}}>
          <Box style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0, backgroundColor: '#2563eb', borderRadius: '8px', paddingLeft: '16px', paddingRight: '16px', height: '36px' }}>
            <AccessTimeIcon sx={{ color: '#fff', fontSize: '16px' }} />
            <Typography sx={{ fontWeight: 700, color: '#fff', fontSize: '13px', fontFamily: 'monospace', whiteSpace: 'nowrap', lineHeight: 1 }}>
              {formatTimeTimer(time)}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'nowrap',
        gap: '4px',
        marginLeft: { xs: 0, sm: 'auto' },
        justifyContent: { xs: 'center', sm: 'flex-end' },
        width: { xs: '100%', sm: 'auto' },
      }}>
        <Button
          onClick={() => {
            if (markedForReview[currentIndex]) {
              handleBookmarkFalse(currentIndex);
            } else {
              handleMarkForReviewAndNext();
            }
          }}
          className="MarkBtn"
          startIcon={
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#6D28D9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 3v1.5M3 21v-6m0 0 2.77-.693a9 9 0 0 1 6.208.682l.108.054a9 9 0 0 0 6.086.71l3.114-.732a48.524 48.524 0 0 1-.005-10.499l-3.11.732a9 9 0 0 1-6.085-.711l-.108-.054a9 9 0 0 0-6.208-.682L3 4.5M3 15V4.5" />
            </svg>
          }
          sx={{ minWidth: "auto", color: '#6D28D9', textTransform: 'none', fontSize: { xs: '11px', md: '12px' }, fontWeight: 500, width: { xs: 'auto', md: '178px' }, height: '32px', gap: '6px', paddingTop: '6px', paddingBottom: '6px', paddingLeft: '12px', paddingRight: '12px', borderRadius: '4px', whiteSpace: 'nowrap', backgroundColor: '#C4B5FD', boxShadow: '0px 1px 0.5px 0.05px #1D293D05', border: 'none', '&:hover': { backgroundColor: '#DDD6FE', boxShadow: '0px 1px 0.5px 0.05px #1D293D05' }, '&.MuiButton-root': { backgroundColor: '#C4B5FD' } }}
        >
          {markedForReview[currentIndex] ? 'Marked for Review' : 'Mark for Review & Next'}
        </Button>
        <Button
          onClick={handleClearResponse}
          className="MarkBtn"
          startIcon={
            <svg width="16" height="16" viewBox="0 0 14 24" fill="none" stroke="#374151" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12.4002 22H4.5999C4.44167 22.0004 4.28493 21.966 4.13871 21.8989C3.99248 21.8317 3.85965 21.7331 3.74786 21.6087L1.35136 18.9427C1.12638 18.6926 1 18.3536 1 18C1 17.6465 1.12638 17.3074 1.35136 17.0574L7.35162 10.3907C7.46306 10.2668 7.59537 10.1686 7.741 10.1015C7.88663 10.0345 8.04272 10 8.20035 10C8.35799 10 8.51408 10.0345 8.6597 10.1015C8.80533 10.1686 8.93765 10.2668 9.04909 10.3907L12.6486 14.3907C12.8736 14.6407 13 14.9798 13 15.3334C13 15.6869 12.8736 16.026 12.6486 16.276L7.50042 22M2.84902 15.3934L8.14605 21.2787" />
            </svg>
          }
          sx={{ minWidth: "auto", color: '#374151', lineHeight: '1.2', textTransform: 'none', fontSize: { xs: '10px', sm: '11px', md: '12px' }, fontWeight: '500' }}
        >
          Clear Response
        </Button>
      </Box>
    </Box>
  </Box>}
                
                
              

                <Box sx={{ maxWidth: '1400px', width: '96%', margin: '0 auto', px: '24px', flex: 1, overflow: 'hidden', paddingBottom: '12px', paddingTop: '12px' }}>
                  {currentQuestion?.question_type !== "MCQ" ?
                    <div id="QuestionPanel" style={{ width: '100%' }}>
                      {isLoading ? (
                        <div style={{ width: '100%', paddingTop: '200px', textAlign: 'center' }}>
                          <LottieLoading loading={isLoading} />
                          {showModuleComplete && (
                            <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255,255,255,0.95)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', zIndex: 9999, padding: '20px', textAlign: 'center' }}>
                              <p style={{ color: '#909bd7', fontSize: '24px', fontWeight: 500, marginBottom: '16px' }}>This Module Is Over</p>
                              <p style={{ fontWeight: 500, marginBottom: '8px' }}>All your work has been saved</p>
                              <p style={{ fontWeight: 500, marginBottom: '4px' }}>You'll move on automatically in just a moment.</p>
                              <p style={{ color: 'red' }}>Do not refresh this page or quit the app.</p>
                            </div>
                          )}
                        </div>
                      ) : currentQuestion && (
                     <div style={{
    display: 'flex',
    flexDirection: isSmallMobile ? 'column' : 'row',
    width: '100%',
    height: isSmallMobile ? 'auto' : 'calc(100vh - 200px)',
    maxHeight: isSmallMobile ? 'calc(100vh - 200px)' : 'none',
    marginBottom: '60px',
    marginTop: '8px',
    backgroundColor: '#ffffff',
    border: '1px solid #dce3f0',
    borderRadius: '8px',
    overflow: isSmallMobile ? 'auto' : 'hidden',
  }}>
    <div style={{
      width: isSmallMobile ? '100%' : '50%',
      borderRight: isSmallMobile ? 'none' : '1px solid #e0e0e0',
      borderBottom: isSmallMobile ? '1px solid #e0e0e0' : 'none',
      padding: '28px 32px',
      overflowY: isSmallMobile ? 'visible' : 'auto',
      backgroundColor: '#ffffff',
    }}>
      <p style={{ color: '#888', fontSize: '10px', fontWeight: 600, letterSpacing: '0.8px', marginBottom: '16px' }}>
        Passage
      </p>
      <div
        dangerouslySetInnerHTML={{ __html: currentQuestion?.passage_text }}
        style={{ fontSize: '13px', color: '#374151', lineHeight: 1.6, userSelect: 'none' }}
        onCopy={(e) => e.preventDefault()}
        onContextMenu={(e) => e.preventDefault()}
      />
    </div>

    <div style={{
      width: isSmallMobile ? '100%' : '50%',
      padding: '28px 32px',
      overflowY: isSmallMobile ? 'visible' : 'auto',
      backgroundColor: '#ffffff',
      display: 'flex',
      flexDirection: 'column',
    }}>
      <p style={{ color: '#555', fontSize: '12px', fontWeight: 500, marginBottom: '16px' }}>
        Question {currentIndex + 1}
      </p>
      <div
        dangerouslySetInnerHTML={{ __html: questionHtml }}
        style={{ fontSize: '13px', color: '#222', lineHeight: 1.6, marginBottom: '16px', userSelect: 'none' }}
        onCopy={(e) => e.preventDefault()}
        onContextMenu={(e) => e.preventDefault()}
      />
      {parsedOptions && parsedOptions?.map((option, index) => {
        const isSelected = selectedAnswers[currentIndex] === option;
        return (
          <button
            key={index}
            type="button"
            onClick={() => handleOptionSelect(option, index)}
            style={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              marginTop: '8px',
              padding: '10px 16px',
              backgroundColor: isSelected ? '#f0f6ff' : '#ffffff',
              border: isSelected ? '2px solid #1976d2' : '1px solid #e0e0e0',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '12px',
              color: '#111',
              textAlign: 'left',
              lineHeight: 1.4,
            }}
          >
            <span style={{
              flexShrink: 0,
              width: '26px',
              height: '26px',
              borderRadius: '50%',
              border: isSelected ? 'none' : '1px solid #aaa',
              backgroundColor: isSelected ? '#1976d2' : 'transparent',
              color: isSelected ? '#fff' : '#555',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 600,
              fontSize: '13px',
              marginRight: '14px',
            }}>{String.fromCharCode(65 + index)}</span>
            <span
              className="optionContent"
              dangerouslySetInnerHTML={{ __html: formatOptionHtml(option) }}
            />
          </button>
        );
      })}
    </div>
  </div>
                      )}
                    </div>

              :
              <Grid
                container
                justifyContent="center"
                alignItems="flex-start"
                style={{ padding: '0', alignContent: 'flex-start' }}
              >
                {
                  isLoading ?
                    <Grid sx={{
                      padding: 1, backgroundColor: "#ffffff",
                      paddingTop: '200px',
                      width: '100%',
                      paddingRight: '0px',
                      marginTop: '60px',
                      paddingleft: '0px',
                      height: 'Calc(100vh - 180px)',
                      overflowX: 'hidden',
                      overflowY: 'auto',
                    }}>
                      <LottieLoading loading={isLoading} />
                      {showModuleComplete && (
                        <Box
                          sx={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(255, 255, 255, 0.95)',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 9999,
                            padding: '20px',
                            textAlign: 'center'
                          }}
                        >
                          <Typography variant="h4" sx={{ color: '#909bd7', marginBottom: 2, fontWeight: '500' }}>
                            This Module Is Over
                          </Typography>
                          <Typography variant="body1" sx={{ marginBottom: 2, fontWeight: '500' }}>
                            All your work has been saved
                          </Typography>
                          <Typography variant="body1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                            You'll move on automatically in just a moment.
                          </Typography>
                          <Typography variant="body1" sx={{ color: 'red' }}>
                            Do not refresh this page or quit the app.
                          </Typography>
                        </Box>
                      )}
                    </Grid> :
                    currentQuestion && (
                      <Box
                        sx={{
                          width: {
                            width: '100%',
                          },
                          marginTop: '8px',
                          backgroundColor: "#ffffff",
                          borderRadius: '8px',
                          border: '1px solid #dce3f0',
                          textAlign: "center",
                          boxShadow: 'none',
                          maxHeight: 'calc(100vh - 200px)',
                          overflowY: 'auto',
                        }}
                        style={{ padding: '25px', }}
                      >
                        <Box
                          sx={{
                            padding: '8px 4px',
                            backgroundColor: "#ffffff",
                            borderRadius: '2px',
                            textAlign: "left",
                            borderBottom: '1px solid #e0e0e0',
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: 1,
                            }}
                          >
                            <Typography variant="subtitle1" sx={{ fontWeight: "500", color: "#555", fontSize: '13px' }}>
                              Question {currentIndex + 1}
                            </Typography>
                          </Box>
                        </Box>
                        <Typography className='questionViewer'
                          dangerouslySetInnerHTML={{ __html: questionHtml }}
                          sx={{
                            marginTop: '5px',
                            width: "100%",
                            textAlign: 'start',
                            fontWeight: '400',
                            fontSize: { xs: "16px", md: "18px" },
                            marginBottom: 1,
                            userSelect: 'none'
                          }}
                          onCopy={(e) => e.preventDefault()}
                          onContextMenu={(e) => e.preventDefault()}
                        />

                              {parsedOptions && parsedOptions?.map((option, index) => {
                                const isSelected = selectedAnswers[currentIndex] === option;
                                return (
                                  <button
                                    key={index}
                                    type="button"
                                    onClick={() => handleOptionSelect(option, index)}
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      width: '100%',
                                      marginTop: '8px',
                                      padding: '10px 16px',
                                      backgroundColor: isSelected ? '#f0f6ff' : '#ffffff',
                                      border: isSelected ? '2px solid #1976d2' : '1px solid #e0e0e0',
                                      borderRadius: '4px',
                                      cursor: 'pointer',
                                      fontSize: '12px',
                                      color: '#111',
                                      textAlign: 'left',
                                      lineHeight: 1.4,
                                    }}
                                  >
                                    <span style={{
                                      flexShrink: 0,
                                      width: '26px',
                                      height: '26px',
                                      borderRadius: '50%',
                                      border: isSelected ? 'none' : '1px solid #aaa',
                                      backgroundColor: isSelected ? '#1976d2' : 'transparent',
                                      color: isSelected ? '#fff' : '#555',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      fontWeight: 600,
                                      fontSize: '13px',
                                      marginRight: '14px',
                                    }}>{String.fromCharCode(65 + index)}</span>
                                    <span
                                      className="optionContent"
                                      dangerouslySetInnerHTML={{ __html: formatOptionHtml(option) }}
                                    />
                                  </button>
                                );
                              })}
                            </Box>
                          )}
                    </Grid>

                  }
                </Box>

                <Popover
                  open={!!questionListAnchorEl}
                  anchorEl={isMobile ? null : questionListAnchorEl}
                  anchorReference={isMobile ? 'anchorPosition' : 'anchorEl'}
                  anchorPosition={
                    isMobile
                      ? { top: window.innerHeight / 2, left: window.innerWidth / 2 }
                      : undefined
                  }
                  onClose={handleCloseQuestionList}
                  anchorOrigin={{ vertical: isMobile ? 'center' : 'top', horizontal: 'center' }}
                  transformOrigin={{ vertical: isMobile ? 'center' : 'bottom', horizontal: 'center' }}
                  disablePortal={false}
                  marginThreshold={isMobile ? 16 : 80}
                  sx={{ '& .MuiPopover-paper': { marginBottom: isMobile ? 0 : '12px' } }}
                  PaperProps={{
                    sx: {
                      borderRadius: '12px',
                      boxShadow: '0 4px 24px rgba(0,0,0,0.10)',
                      border: '1px solid #E5E7EB',
                      overflow: 'visible',
                      p: '16px',
                      width: { xs: '92vw', sm: '90vw', md: '500px' },
                      maxWidth: { xs: '92vw', sm: '90vw', md: '500px' },
                      minHeight: '274px',
                      mb: isMobile ? 0 : '8px',
                    },
                  }}
                >
                  <Box sx={{
                    display: { xs: 'none', md: 'block' },
                    position: 'absolute', bottom: -9, left: '50%', transform: 'translateX(-50%)',
                    width: 0, height: 0, borderLeft: '10px solid transparent', borderRight: '10px solid transparent',
                    borderTop: '9px solid #E5E7EB', zIndex: 1, pointerEvents: 'none',
                  }} />
                  <Box sx={{
                    display: { xs: 'none', md: 'block' },
                    position: 'absolute', bottom: -7, left: '50%', transform: 'translateX(-50%)',
                    width: 0, height: 0, borderLeft: '9px solid transparent', borderRight: '9px solid transparent',
                    borderTop: '8px solid #FFFFFF', zIndex: 2, pointerEvents: 'none',
                  }} />
                  <AdaptiveQuestionPalette
                    questions={questions}
                    currentIndex={currentIndex}
                    selectedAnswers={selectedAnswers}
                    markedForReview={markedForReview}
                    visitedMap={visitedMap}
                    handleQuestionSelect={(idx) => {
                      handleQuestionSelect(idx);
                      handleCloseQuestionList();
                    }}
                  />
                </Popover>

                <Box sx={{ backgroundColor: "#FFFFFF", height: { xs: 'auto', md: '72px' }, minHeight: { xs: '84px', md: '72px' }, display: 'flex', alignItems: 'center', position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 100, py: { xs: 1, md: 0 } }}>
                  <Box sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: 'center',
                    justifyContent: { xs: 'center', md: 'space-between' },
                    maxWidth: '1400px',
                    width: '96%',
                    margin: '0 auto',
                    px: '24px',
                    gap: { xs: 0.75, md: 0 },
                  }}>
                    <Typography sx={{
                      fontWeight: '500',
                      fontSize: { xs: '12px', md: '14px' },
                      color: '#333',
                      minWidth: { xs: 'auto', md: '120px' },
                      textAlign: { xs: 'center', md: 'left' },
                    }}>
                      {currentSubject?.sectionName || userInfo?.name}
                    </Typography>

                    <Box sx={{
                      display: { xs: 'flex', md: 'contents' },
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      width: { xs: '100%', md: 'auto' },
                    }}>
                      <Button
                        variant="contained"
                        id="ViewQuestionAll"
                        disabled={isPaused || isLoading || isSubmitting}
                        onClick={questionListAnchorEl ? handleCloseQuestionList : handleOpenQuestionList}
                        endIcon={<KeyboardArrowDownIcon style={{ transform: questionListAnchorEl ? 'rotate(0deg)' : 'rotate(180deg)', transition: 'transform 0.2s' }} />}
                        style={{
                          backgroundColor: isPaused || isLoading || isSubmitting ? "#d3d3d3" : "#2563EB",
                          borderRadius: '4px',
                          color: isPaused || isLoading || isSubmitting ? "#999999" : "#ffffff",
                          textTransform: 'none',
                          fontSize: '14px',
                          height: '36px',
                          whiteSpace: 'nowrap',
                          gap: '4px',
                          paddingTop: '4px',
                          paddingBottom: '4px',
                          paddingLeft: '12px',
                          paddingRight: '12px',
                        }}
                      >
                        View all questions
                      </Button>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Button
                          variant="contained"
                          onClick={handleBack}
                          disabled={currentIndex === 0 || isPaused || isLoading || isSubmitting}
                          startIcon={<ChevronLeftIcon sx={{ fontSize: '18px !important' }} />}
                          style={{
                            background: '#fff',
                            borderRadius: '4px',
                            color: (currentIndex === 0 || isPaused || isLoading || isSubmitting) ? "#999999" : "#333",
                            textTransform: 'none',
                            border: '1px solid #EEEEEE',
                            boxShadow: '0px 1px 0.5px 0.05px #1D293D05',
                            height: '32px',
                            minWidth: '73px',
                            gap: '6px',
                            paddingTop: '6px',
                            paddingBottom: '6px',
                            paddingLeft: '12px',
                            paddingRight: '12px',
                          }}
                        >
                          Back
                        </Button>
                        {currentIndex === questions?.length - 1 ? (
                          <Button variant="contained"
                            style={{ background: (isPaused || isSubmitting || isLoading) ? '#d3d3d3' : '#193CB8', borderRadius: '4px', color: "#fff", textTransform: 'none', boxShadow: '0px 0px 0px 2px #BEDBFF', height: '32px', minWidth: '73px', paddingTop: '6px', paddingBottom: '6px', paddingLeft: '12px', paddingRight: '12px' }}
                            onClick={handleSubmit} disabled={isPaused || isSubmitting || isLoading}>
                            {isLoading ? "Submitting..." : "Submit"}
                          </Button>
                        ) : (
                          <Button variant="contained"
                            endIcon={<ChevronRightIcon sx={{ fontSize: '18px !important' }} />}
                            style={{ background: '#193CB8', borderRadius: '4px', color: "#fff", textTransform: 'none', boxShadow: '0px 0px 0px 2px #BEDBFF', height: '32px', minWidth: '73px', gap: '6px', paddingTop: '6px', paddingBottom: '6px', paddingLeft: '12px', paddingRight: '12px' }} onClick={() => handleNext()} disabled={isPaused || isLoading}>
                            Next
                          </Button>
                        )}
                      </Box>
                    </Box>
                  </Box>
                </Box>

                {currentQuestion?.question_type === "MCQ" && testView && (
                  <Box sx={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', pointerEvents: 'none', zIndex: 1300, overflow: 'hidden' }}>
                    <Box
                      id="calc-drag-icon"
                      sx={{
                        position: 'absolute',
                        width: '52px',
                        height: '52px',
                        pointerEvents: 'auto',
                        userSelect: 'none',
                        left: `${calcPos.current.x}px`,
                        top: `${calcPos.current.y}px`,
                      }}
                    >
                      {calculatorOpen && (() => {
                        const BTN = 52;
                        const CALC_W = 320;
                        const CALC_H = 420;
                        const openRight = calcPos.current.x + BTN + CALC_W + 8 <= window.innerWidth;
                        const openDown = calcPos.current.y + CALC_H + 8 <= window.innerHeight;
                        return (
                          <Box
                            className="calculator-content"
                            sx={{
                              position: 'absolute',
                              ...(openRight ? { left: BTN + 8 } : { right: BTN + 8 }),
                              ...(openDown ? { top: 0 } : { bottom: 0 }),
                              borderRadius: '12px',
                              overflow: 'hidden',
                              boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
                              backgroundColor: '#fff',
                              cursor: 'default',
                              width: '320px',
                              zIndex: 2,
                            }}
                          >
                            <Box onClick={() => setCalculatorOpen(false)} sx={{ position: 'absolute', top: '8px', right: '8px', width: '24px', height: '24px', borderRadius: '50%', backgroundColor: '#f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', zIndex: 10, '&:hover': { backgroundColor: '#e5e7eb' } }}>
                              <CloseIcon sx={{ fontSize: 14, color: '#dc2626' }} />
                            </Box>
                            <Box sx={{ pt: '8px', backgroundColor: '#fff', borderRadius: '12px 12px 0 0' }}>
                              <Calculator />
                            </Box>
                          </Box>
                        );
                      })()}

                    <Tooltip title={calculatorOpen ? 'Close Calculator' : 'Calculator'}>
                      <Box
                        onMouseDown={handleCalcMouseDown}
                        onClick={() => {
                          if (calcDraggedRef.current) { calcDraggedRef.current = false; return; }
                          setCalculatorOpen(prev => !prev);
                        }}
                        sx={{
                          width: '52px', height: '52px', borderRadius: '50%',
                          backgroundColor: '#1976d2',
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                          cursor: 'grab',
                          '&:active': { cursor: 'grabbing' },
                          boxShadow: '0px 4px 12px rgba(0,0,0,0.3)',
                          transition: 'background-color 0.2s',
                          '&:hover': { backgroundColor: '#1565c0' },
                          WebkitUserDrag: 'none',
                        }}
                      >
                        <img alt='calculator' src={IconCalculator} draggable={false}
                          style={{ width: '28px', height: '28px', filter: 'brightness(0) invert(1)', pointerEvents: 'none' }} />
                      </Box>
                    </Tooltip>
                  </Box>
                </Box>
              )}
          </Box>
        </>
      }
      <Snackbar open={isopenSnackbar} snackbarTitle={snackbarTitle} close={() => setOpenSnackbar(false)} />
      <Dialog
        open={openConfirmDialog}
        onClose={() => { setOpenConfirmDialog(false); setIsSubmitting(false); }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" style={{ paddingBottom: '0px !important' }} sx={{ pb: 0 }} textAlign={'center'}>
          {"Do you really want to submit"}

        </DialogTitle>
            <DialogContent style={{ borderTop: '1px solid rgb(163, 163, 163)', borderBottom: '1px solid rgb(163, 163, 163)', overflow: { sx: 'auto', sm: 'auto', md: 'hidden' } }}>

              <Box id="QuestionModulePop"
                sx={{
                  margin: 'auto',
                  backgroundColor: 'white',
                  padding: '0px !important',
                  paddingTop: '8px !important',
                  overflowX: 'hidden',
                  overflowY: 'hidden', 
                }}
              >

                <Box sx={{ display: "flex", flexWrap: 'wrap', gap: 2, pb: 1.5, borderBottom: '1px solid #e5e7eb', alignItems: 'center' }}>                  {[
                  { label: 'Not Visited', borderColor: '#9ca3af' },
                  { label: 'Not Answered', borderColor: '#f87171' },
                  { label: 'Answered', borderColor: '#4ade80' },
                  { label: 'Marked for Review', borderColor: '#c084fc' },
                ].map(({ label, borderColor }) => (
                  <Box key={label} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box sx={{ width: 20, height: 20, borderRadius: '50%', border: `2px solid ${borderColor}`, backgroundColor: 'transparent', flexShrink: 0 }} />
                    <Typography variant="body2" sx={{ fontSize: '12px', color: '#374151' }}>{label}</Typography>
                  </Box>
                ))}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%', mb: '4px' }}>
                    <Box sx={{ position: 'relative', width: 20, height: 20, flexShrink: 0 }}>
                      <Box sx={{ width: 20, height: 20, borderRadius: '50%', border: '2px solid #a855f7', backgroundColor: 'transparent' }} />
                      <Box sx={{ position: 'absolute', top: -4, right: -4, width: 12, height: 12, borderRadius: '50%', backgroundColor: '#7c3aed', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.8" stroke="white" width={7} height={7}>
                          <path strokeLinecap="round" strokeLinejoin="round" d="M3 3v1.5M3 21v-6m0 0 2.77-.693a9 9 0 0 1 6.208.682l.108.054a9 9 0 0 0 6.086.71l3.114-.732a48.524 48.524 0 0 1-.005-10.499l-3.11.732a9 9 0 0 1-6.085-.711l-.108-.054a9 9 0 0 0-6.208-.682L3 4.5M3 15V4.5" />
                        </svg>
                      </Box>
                    </Box>
                    <Typography variant="body2" sx={{ fontSize: '12px', color: '#374151' }}>Answered &amp; Marked</Typography>
                  </Box>
                </Box>

                <Grid container spacing={1} sx={{ padding: '16px 4px 4px 4px', overflowX: 'hidden', overflowY: 'auto', maxHeight: '260px', margin: '0 !important', width: '100% !important' }}>                {questions && questions?.length > 0 && questions.map((q, index) => {
                const isSelected = currentIndex === index;
                const isAnswered = selectedAnswers[index] !== undefined && selectedAnswers[index] !== null;
                const isMarkedForReview = markedForReview[index];
                const isVisited = visitedMap[index] === true;

                let backgroundColor = "#f0f0f0";   
                let borderColor = "#c8c8c8";
                let color = "#555";

                if (isAnswered && isMarkedForReview) {
                  backgroundColor = "#faf5ff"; borderColor = "#a855f7"; color = "#7c3aed";
                } else if (isMarkedForReview) {
                  backgroundColor = "#faf5ff"; borderColor = "#a855f7"; color = "#7c3aed";
                } else if (isAnswered) {
                  backgroundColor = "#f0fff4"; borderColor = "#4ade80"; color = "#16a34a";
                  } else if (isVisited) {
                    backgroundColor = "#fff0f0"; borderColor = "#f87171"; color = "#ef4444";
                } else {
                  backgroundColor = "#f0f0f0"; borderColor = "#c8c8c8"; color = "#555";
                }
                if (isSelected) {
                  backgroundColor = "#fff0f0"; borderColor = "#f87171"; color = "#ef4444";
                }

                return (
                  <Grid item xs={2} key={index}>
                    <Box onClick={() => handleQuestionSelect(index)}
                      sx={{
                        backgroundColor,
                        border: `1.5px solid ${borderColor}`,
                        color,
                        width: "36px",
                        height: "36px",
                        fontSize: "13px",
                        fontWeight: "600",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        borderRadius: '8px',
                        boxShadow: isSelected ? '0 0 0 2px #fecaca' : 'rgba(0,0,0,0.06) 0px 1px 2px',
                        position: "relative",
                        "&:hover": { transform: "scale(1.07)" }
                      }}
                    >
                     {(isMarkedForReview && isAnswered) && (
                        <Box sx={{
                          position: "absolute",
                          top: -6,
                          right: -6,
                          width: 14,
                          height: 14,
                          borderRadius: "50%",
                          backgroundColor: isAnswered ? "#7c3aed" : "#c084fc",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          zIndex: 1,
                        }}>
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                            strokeWidth="1.8" stroke="white" width={8} height={8}>
                            <path strokeLinecap="round" strokeLinejoin="round"
                              d="M3 3v1.5M3 21v-6m0 0 2.77-.693a9 9 0 0 1 6.208.682l.108.054a9 9 0 0 0 6.086.71l3.114-.732a48.524 48.524 0 0 1-.005-10.499l-3.11.732a9 9 0 0 1-6.085-.711l-.108-.054a9 9 0 0 0-6.208-.682L3 4.5M3 15V4.5" />
                          </svg>
                        </Box>
                      )}
                      {index + 1}
                    </Box>
                  </Grid>
                );
              })}
            </Grid>
            <p style={{
              height: '5px',
              display: 'flex',
              justifyContent: 'center',
              margin: '0'
            }}>
              <span className="reviewBtn"
                style={{
                  position: 'relative',

                    }}><br /></span>
                </p>
              </Box>
            </DialogContent>
            <DialogActions>
              <Box style={{ display: 'flex', justifyContent: 'space-between', flex: 2, padding: '0 20px', marginBottom: '10px' }}>
                <Button
                  variant="outlined"
                  onClick={() => { setOpenConfirmDialog(false); setIsSubmitting(false); }}
                  borderColor="#1976d2"
                  sx={{
                    border: '1px solid #1976d2',
                    borderRadius: '4px',
                    color: '#1976d2',
                    transition: 'background 0.2s',
                    '&:hover': {
                      border: '1px solid #1976d2',
                      backgroundColor: '#e1f0ff',
                    },
                  }}
                >
                  {"Back"}
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => handlePostUserResult()}
                  //  color="#1976d2"
                  sx={{
                    border: '1px solid #1976d2',
                    borderRadius: '4px',
                    color: '#1976d2',
                    transition: 'background 0.2s',
                    '&:hover': {
                      border: '1px solid #1976d2',
                      backgroundColor: '#e1f0ff',
                    },
                  }}
                >
                  {"Submit"}
                </Button>
              </Box>
            </DialogActions>
          </Dialog>


      <Dialog open={showCongratulationsModal} disableEscapeKeyDown slotProps={{ backdrop: { style: { backgroundColor: '#fff' } } }} sx={{ '& .MuiDialog-paper': { borderRadius: '12px', padding: '20px', textAlign: 'center', minWidth: '400px' } }}>
        <DialogContent sx={{ padding: '20px' }}>
          <div style={{ marginTop: '0px', paddingBottom: '10px' }}>
            <div className="flex justify-center mb-4">
              <div className="relative inline-block">
                <img style={{ justifySelf: 'center', width: '60px', marginBottom: '10px' }} src={TestComplete} alt="Timeout Icon" className="w-16 h-16" />
              </div>
            </div>

            <h2 className="text-xl font-bold text-blue-600" id="canvas" style={{ textAlign: 'center', marginTop: '5px', fontWeight: '700', color: "#6c98fd !important" }}>Congratulations!</h2>
            <p className="text-gray-600 mt-2" style={{
              textAlign: 'center', marginTop: '10px'
            }}>
              You have successfully completed the Test.
            </p>

          </div>

              <LottieLoading />
            </DialogContent>
          </Dialog>
        </>}
                <ProctoringWarningModal open={showWarning} violationCount={violationCount} violationType={lastViolationType} onClose={dismissWarning} />
        
    </Page>
  );
};

export default AdativeAssessment;